import React from "react";
import AuthMenuPanel from "components/common/AuthMenuPanel";
import AuthUserBox from "components/common/AuthUserBox";

const ActivityDetailsLeftPanel = () => {
  return (
    <div className="pnl_leftpnl hidden_mobile">
      <AuthUserBox />
      <AuthMenuPanel moduleName="activity" />
    </div>
  );
};

export default ActivityDetailsLeftPanel;
